import axios from "@/plugins/axios";

let url = "/api/console/members/with-deposit";

/** @typedef {object} Member */

export const withDeposit = {
    /**
     * @param {import("axios").AxiosRequestConfig} data
     * @returns {Promise<{ summary: { totalCount: number }, members: Member[]}>}
     */
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },

    /**
     * @param {{ _id: string }} data
     * @returns {Promise<{ member: Member }>}
     */
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },

    /**
     * @param {Partial<Member>} data
     * @returns {Promise<{ member: Member }>}
     */
    put(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },
};

export default withDeposit;
